/**
 * Ryze R Realm Warp — ground channel then self teleport (FID-ABL-05).
 * Ally portal zone deferred; this stub verifies channel → blink.
 */

import { clampPointToward, scaleLolDistance } from '../combat/abilityArea.js';

export const RYZE_REALM_WARP = Object.freeze({
  manaCost: 100,
  range: 3000,
  channelTime: 2,
  radius: 275,
  cooldown: 80
});

/** @deprecated prefer clampPointToward with caster scale — kept for engine tests. */
export function clampRealmWarpPoint(cx, cy, tx, ty, range) {
  const dx = tx - cx;
  const dy = ty - cy;
  const dist = Math.hypot(dx, dy) || 1;
  if (dist <= range) return { x: tx, y: ty };
  const t = range / dist;
  return { x: cx + dx * t, y: cy + dy * t };
}

export function beginRyzeRealmWarp(caster, targetX, targetY) {
  if (!caster || caster.isDead) return false;
  if (caster.realmWarpChannel) return false;
  if ((caster.mp || 0) < RYZE_REALM_WARP.manaCost) return false;
  caster.mp -= RYZE_REALM_WARP.manaCost;
  const dest = clampPointToward(
    caster.x,
    caster.y,
    targetX,
    targetY,
    RYZE_REALM_WARP.range,
    caster
  );
  caster.realmWarpChannel = {
    remaining: RYZE_REALM_WARP.channelTime,
    x: dest.x,
    y: dest.y,
    scale: scaleLolDistance(1, caster)
  };
  return true;
}

export function tickRyzeRealmWarp(caster, dt = 0) {
  const ch = caster?.realmWarpChannel;
  if (!ch) return false;
  ch.remaining -= dt;
  if (ch.remaining > 0) return false;
  caster.x = ch.x;
  caster.y = ch.y;
  if (Number.isFinite(caster.z)) caster.z = ch.y;
  caster.realmWarpChannel = null;
  return true;
}
